import {
    Box,
    Grid,
    Stack,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import EmailIcon from '@mui/icons-material/Email';
import CallIcon from '@mui/icons-material/Call';
import data from '../../data/data.json';
import { Link } from 'react-router-dom';
import DotGrid from '../../components/effects/dotGrid/dotGrid';

const FooterView = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <>
            <Stack
                direction='column'
                justifyContent='center'
                alignItems='center'
                className='bodyPadding'
                pb={3}
                spacing={{xs: 4, md: 5}}
                position='relative'
                id='footerRef'
            >
                <div 
                    style={{ 
                        width: '100%', 
                        position: 'absolute',
                        overflow: 'hidden',
                        zIndex: -1,
                        inset: 0,
                        height: '100%'
                    }}
                >
                    <DotGrid
                        dotSize={2}
                        gap={15}
                        baseColor="#ffffff4a"
                        activeColor="#ffffffff"
                        proximity={isMobile ? 0 : 120}
                        shockRadius={isMobile ? 0 : 500}
                        shockStrength={isMobile ? 0 : 50}
                        resistance={isMobile ? 0 : 70}
                        returnDuration={isMobile ? 0 : 1}
                    />
                </div>

                {/* Description, Logo and Contact */}
                <Grid
                    direction='row'
                    justifyContent={{xs: 'center', md: 'space-between'}}
                    alignItems='center'
                    container
                    width='100%'
                >
                    {/* Logo - Small devices */}
                    <Grid 
                        display={{xs: 'flex', md: 'none'}}
                        direction='row'
                        justifyContent='center'
                        size={{xs: 5, md: 4}}
                    >
                        <Box
                            sx={{
                                width: '100%',
                                pb: 2
                            }}
                        >
                            <img 
                                src='/images/logos/EdOnline Icon - White.png' 
                                alt='logo' 
                                width='100%' 
                                style={{
                                    animation: 'fish2Animation 1.5s infinite ease-in-out'
                                }}
                            />
                        </Box>
                    </Grid>

                    {/* Description */}
                    <Grid 
                        display='flex'
                        direction='row'
                        justifyContent={{xs: 'center', md: 'start'}}
                        size={{xs: 12, md: 4}}
                    >
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: {xs: 12, md: 14, lg: 16},
                                textAlign: {xs: 'center', md: 'left'},
                                color: 'white'
                            }}
                        >
                            {t('footer.description')}
                        </Typography>
                    </Grid>

                    {/* Logo - Large devices */}
                    <Grid 
                        display={{xs: 'none', md: 'flex'}}
                        direction='row'
                        justifyContent='center'
                        size={{xs: 5, md: 4}}

                    >
                        <Box
                            sx={{
                                width: '50%'
                            }}
                        >
                            <img 
                                src='/images/logos/EdOnline Icon - White.png' 
                                alt='logo' 
                                width='100%' 
                                style={{
                                    animation: 'fish2Animation 1.5s infinite ease-in-out'
                                }}
                            />
                        </Box>
                    </Grid>

                    {/* Contact */}
                    <Grid 
                        display='flex'
                        direction='row'
                        justifyContent={{xs: 'center', md: 'end'}}
                        size={{xs: 12, md: 4}} 
                        sx={{pt: {xs: 2, md: 0}}}
                    >
                        <Stack
                            direction='column'
                            justifyContent='center'
                            alignItems='center'
                            spacing={1}
                        >
                            {/* <ContactDetails 
                                icon={<PlaceIcon sx={{color: 'white'}}/>} 
                                value={t('contact.address')}
                            /> */}
                            
                            <ContactDetails 
                                icon={<EmailIcon sx={{color: 'white'}}/>} 
                                value={data.contact.email}
                                link={`mailto:${data.contact.email}`}
                            />
                            
                            <ContactDetails 
                                icon={<CallIcon sx={{color: 'white'}}/>} 
                                value={data.contact.mobile.label} 
                                link={data.contact.mobile.whatsappLink}
                            />
                        </Stack>
                    </Grid>
                </Grid>

                {/* Policies */}
                <Grid
                    direction={{xs: 'column-reverse', md: 'row'}}
                    justifyContent='center'
                    alignItems='center'
                    container
                    width='100%'
                    spacing={{xs: 4, md: 5}}
                >
                    <Grid size={{xs: 12, md: 6}}>
                        <Stack
                            direction='column'
                            justifyContent='center'
                            alignItems={{xs: 'center', md: 'start'}}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: {xs: 12, md: 12},
                                    textAlign: 'left',
                                    color: 'white'
                                }}
                            >
                                {`${process.env.REACT_APP_ENV} v${process.env.REACT_APP_APP_VERSION}`}
                            </Typography>

                            <Link to="https://code3x.tech" target='_blank' style={{textDecoration: 'none'}}>
                                <Typography
                                    sx={{
                                        fontWeight: 400,
                                        fontSize: {xs: 12, md: 12},
                                        textAlign: 'left',
                                        color: 'white',
                                        cursor: 'pointer',
                                        '&: hover': {
                                            transform: 'scale(0.99)'
                                        }
                                    }}
                                >
                                    Powered By code3x
                                </Typography>
                            </Link>
                        </Stack>
                    </Grid>

                    <Grid 
                        size={{xs: 12, md: 6}}
                        display='flex'
                        justifyContent={{xs: 'center', md: 'end'}}
                    >
                        <Stack
                            direction='row'
                            spacing={4}
                        >
                            <Link 
                                to="/privacy-policy" 
                                style={{
                                    textDecoration: 'none'
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontWeight: 400,
                                        fontSize: {xs: 12, md: 14, lg: 16},
                                        textAlign: 'left',
                                        color: 'white',
                                        cursor: 'pointer',
                                        '&: hover': {
                                            transform: 'scale(0.9)'
                                        }
                                    }}
                                >
                                    {t('footer.privacyPolicy')}
                                </Typography>
                            </Link>

                            <Link 
                                to="/terms-and-conditions" 
                                style={{
                                    textDecoration: 'none'
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontWeight: 400,
                                        fontSize: {xs: 12, md: 14, lg: 16},
                                        textAlign: 'left',
                                        color: 'white',
                                        cursor: 'pointer',
                                        '&: hover': {
                                            transform: 'scale(0.9)'
                                        }
                                    }}
                                >
                                    {t('footer.termsAndConditions')}
                                </Typography>
                            </Link>
                        </Stack>
                    </Grid>
                </Grid>

                {/* Copyrights */}
                <Typography
                    sx={{
                        fontWeight: 400,
                        fontSize: {xs: 12},
                        textAlign: 'center',
                        color: 'white'
                    }}
                >
                    {`© ${new Date().getFullYear()} Edliena. All Rights Reserved.`}
                </Typography>
            </Stack>
        </>
    );
}

export default FooterView;

const ContactDetails = ({icon, value, link}) => {
    return (
        <>
            <Link to={link} target='_blank' style={{textDecoration: 'none'}}>
                <Stack
                    direction='row'
                    justifyContent='start'
                    alignItems='center'
                    spacing={1}
                    sx={{
                        cursor: link ? 'pointer' : 'default',
                        '&: hover': {
                            transform: link ? 'scale(0.9)' : 'scale(1)'
                        }
                    }}
                >
                    {icon}

                    <Typography
                        sx={{
                        fontWeight: 400,
                        fontSize: {xs: 12, md: 14, lg: 16},
                            textAlign: 'left',
                            color: 'white'
                        }}
                    >
                        {value}
                    </Typography>
                </Stack>
            </Link>
        </>
    );
}